import { useAutoScrollTop } from "app/custom-hooks/useAutoScrollTop";
import { SegmentWizardContextProvider } from "app/pages/segments/redesigned-wizard/segment-wizard/SegmentWizardContextProvider";

import { SegmentWizard } from "../../redesigned-wizard/segment-wizard/SegmentWizard";

export const SegmentsWizardWrapper = () => {
    const autoScrollRef = useAutoScrollTop();

    return (
        <div
            className="sw-layout-scrollable-element use-sticky-css-rendering"
            ref={autoScrollRef}
        >
            <SegmentWizardContextProvider>
                <SegmentWizard />
            </SegmentWizardContextProvider>
        </div>
    );
};
